// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const QrsAxisOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"circle","attrs":{"cx":"12","cy":"12","fill":"none","r":"7","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M12 2v20M2 12h20M12 12V6M12 12l8 8","stroke-width":"2","stroke":"currentColor"}}]},"name":"qrs-axis","theme":"outlined"};

const QrsAxisOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={QrsAxisOutlinedSvg} />;
  QrsAxisOutlined.displayName = 'QrsAxisOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(QrsAxisOutlined);
